import FormBuilder from './FormBuilder';
import bootstrap4 from './bootstrap4/defaults';

export const defaults = {
  bootstrap4
};

export default FormBuilder;



// WEBPACK FOOTER //
// ./src/react-formbuilder.js